export class FieldMappingModel {
    id;
    fieldName;
    dataType;
    dynamic;
    logType;
    alias;
}
//# sourceMappingURL=field-mapping.js.map